import { useState } from "react";
import { Theme } from "react-daisyui";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ThemePicker from "../src/layout/ThemePicker";
import CatapultSessions from "./matches/CatapultSessions";
import MatchTracker from "./matches/MatchTracker";
import ForgotPassword from "./pages/ForgotPassword";
import FrontPage from "./pages/FrontPage";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Translation from "./pages/Translation";

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") ?? "garden");
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "garden"
  );

  return (
    <>
      <Theme dataTheme={currentTheme}>
        {/* <html data-theme={theme}> */}
        <Router>
          <div className="flex flex-col">
            <main className="mx-2 px-2 pb-2">
              {/* <main className="flex flex-col w-full h-[99vh] sm:mx-2 sm:mb-2 overflow-hidden"> */}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/themepicker" element={<ThemePicker />} />
                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/notfond" element={<NotFound />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/translation" element={<Translation />} />
                <Route path="/frontpage" element={<FrontPage />} />
                <Route path="/matchtracker" element={<MatchTracker />} />
                <Route path="/catapultsessions" element={<CatapultSessions />} />
                <Route path="/*" element={<NotFound />} />
              </Routes>
            </main>
          </div>
        </Router>
        <ToastContainer />
        {/* </html> */}
      </Theme>
    </>
  );
}

export default App;
